import { Button, DrawerFooter } from '@chakra-ui/react';

import { Filter } from 'types';
import { clearFilter } from '../filterFactoryMethods';

export interface IProps {
  filter: Filter;
  isActive: boolean;
  onCloseFilterSetup: () => void;
  hasClearThisFilters?: boolean;
  onFilterConfirmLabel?: string;
}
export interface IDispatchProps {
  saveFilter: (key: string, values: string[]) => void;
}

export const Footer = ({
  filter,
  onCloseFilterSetup,
  saveFilter,
  isActive,
  hasClearThisFilters = true,
  onFilterConfirmLabel,
}: IProps & IDispatchProps) => {
  const clearFilterAndClose = () => {
    clearFilter(filter, saveFilter);
    onCloseFilterSetup();
  };
  return (
    <DrawerFooter data-selector="filter-footer">
      {hasClearThisFilters && (
        <Button
          variant="secondary"
          mr="auto"
          onClick={clearFilterAndClose}
          isDisabled={!isActive}
          data-selector="clear-this-filter"
        >
          Clear this filter
        </Button>
      )}
      <Button variant="secondary" onClick={onCloseFilterSetup} data-selector="close-button">
        {onFilterConfirmLabel || 'Close'}
      </Button>
    </DrawerFooter>
  );
};
